
export default {
  name: "EoLogoBlauwBloed",
  props: {
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl)
     */
    size: {
      type: String,
      default: "",
    },
    /**
     * Style: hex value of color
     */
    color: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      viewbox: {
        small: {x: 13, y: 11},
        large: {x: 55, y: 26},
      },
    };
  },
  computed: {
    activeSize() {
      switch (this.size) {
        case "xs":
        case "sm":
          return "small";
        case "md":
        case "lg":
        case "xl":
          return "large";
        default:
          return "large";
      }
    },
  },
};
